import React from 'react';
import { BriefCreationVariant } from '../../context/BriefCreationContext';
import { OnboardingRoutingWrapper } from './OnboardingRouterWrapper';

const WrapperComponent = (variant?: BriefCreationVariant): React.ComponentType<{ children: React.ReactNode }> => {
  switch (variant) {
    case 'onboarding_routing':
      return OnboardingRoutingWrapper;

    case 'drawer':
      return React.Fragment;

    default:
      return React.Fragment;
  }
};

export default WrapperComponent;
